class VariantUpsell {
  constructor(root) {
    this.root = root;
    this.productForm = document.querySelector('[is="product-form"]');
    this.formInitialized = false;

    if (!this.root) {
      console.warn("VariantUpsell: missing required elements");
      return;
    }

    this.init();
  }
  initFormEvents() {
    if (this.formInitialized) return;

    const attachListeners = () => {
      if (this.formInitialized) return;

      // Listen for upsell product checked
      this.root.addEventListener("variant-form:changed", (e) => {
        const criteria = e.detail?.criteria;
        if (criteria) {
          this.toggleUpsellProduct(criteria);
        }
      });

      this.root
        .querySelectorAll(".variant-upsell__product-item")
        .forEach((product) => {
          // 🔑 Extract variant JSON from checkbox
          const checkbox = product.querySelector(
            'input[type="checkbox"][data-product]'
          );
          checkbox.addEventListener("change", (e) => {
            try {
              const productData = JSON.parse(
                checkbox.getAttribute("data-product")
              );

              const variant = productData?.variants?.[0] || null;

              if (variant && this.productForm) {
                // 🔥 Dispatch custom event with variant payload
                this.productForm.dispatchEvent(
                  new CustomEvent("variant-upsell:product-checked", {
                    bubbles: true,
                    detail: {
                      product: productData,
                      variant: variant,
                    },
                  })
                );
              }
            } catch (err) {
              console.error("Invalid JSON in data-product", err);
            }
          });
        });

      this.root
        .querySelector(".variant-upsell__header .btn--collapse")
        .addEventListener("click", (e) => {
          this.root.classList.toggle("--collapsed");
          this.root
            .querySelector(".variant-upsell__content")
            .classList.toggle("--collapsed");
        });
      //   this.root.addEventListener("variant-upsell:product-checked", (e) => {
      //     const variantId = e.detail?.variant_id;
      //     if (variantId) {
      //       this.addVariantToForm(variantId);
      //     }
      //   });

      this.formInitialized = true;
    };

    setTimeout(() => attachListeners(), 1000); // tenta de novo depois de 2s
  }

  init() {
    if (this.root.querySelectorAll("[data-upsell-item='active']").length > 0) {
      this.root.classList.add("--visible");
    }
    this.initFormEvents();
  }
  toggleUpsellProduct(criteria = {}) {
    const allProducts = this.root.querySelectorAll("[data-upsell-static]");

    allProducts.forEach((product) => {
      const entries = Object.entries(criteria);

      if (entries.length === 0) {
        // No filters → show all
        // product.style.display = "flex";

        return;
      }

      // OR condition: show if at least one filter matches
      const matches = entries.some(([attr, value]) => {
        const attrValue = product.getAttribute(attr);
        return (
          attrValue && attrValue.toLowerCase() === String(value).toLowerCase()
        );
      });

      // product.style.display = matches ? "flex" : "none";
      if (matches) {
        product.setAttribute(`data-upsell-item`, "active");
      } else {
        product.setAttribute(`data-upsell-item`, "");
      }
    });
    if (this.root.querySelectorAll("[data-upsell-item='visible']").length > 0) {
      this.root.classList.add("--visible");
    }
  }
}

// Usage (initialize once DOM is ready)
document.addEventListener("DOMContentLoaded", () => {
  const variantUpsellEl = document.querySelector("variant-upsell");
  if (variantUpsellEl) new VariantUpsell(variantUpsellEl);
});
